function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationDiploma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "education_x5F_diploma",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32.618",
    style: {
      enableBackground: "new 0 0 32 32.618"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M16,26c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,26,16,26z M16,20 c-1.103,0-2,0.897-2,2s0.897,2,2,2s2-0.897,2-2S17.103,20,16,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "19,32.618 16,31.118 13,32.618 13,24 15,24 15,29.382 16,28.882 17,29.382 17,24 19,24  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "32,30 21,30 21,28 30,28 30,2 2,2 2,28 11,28 11,30 0,30 0,0 32,0  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    style: {
      fill: "#FD5C3F"
    },
    width: 22,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationDiploma);
export default __webpack_public_path__ + "static/media/education_diploma.3554f69826c507830e956718737746ed.svg";
export { ForwardRef as ReactComponent };